import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {TableComponent} from "../../ui/table/table.component";
import {ShopBaseComponent} from "../shop-base.component";

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
})
export class CartComponent extends ShopBaseComponent {

    @ViewChild('productList') productList: TableComponent | undefined;
    constructor(public serviceInjector: Injector,) {
        super(serviceInjector);
    }

    cartProducts: any[] = [];

    ngAfterViewInit() {
        this.loadData();
    }

    loadData() {
        this.cartProducts = this.getProductsLocalStorage();
        console.log(this.cartProducts)
        setTimeout(() => {
            this.productList?.setData(this.cartProducts);
        }, 100)
    }


    removeCartProducts(product: any) {
        this.removeProductLocalStorage(product);
        this.loadData();
    }

}
